import React from "react";

const Leaderboard = (props) => {
  const formatNumber = (num) => {
    let value = num;
    const res = String(num).split(".");
    if (res.length === 1 || res[1].length <= 3) {
      value = value
        .replace(/\.00$/, "")
        .replace(/\.000$/, "")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    return value;
  };
  return (
    <div className="inner-row gutters constrain overlay_lp__content leaderboard">
      <div className="col-12">
        <h2>Top Fundraisers</h2>
      </div>
      <div className="col-4">
        {props.leaderboard.slice(0, 17).map((individual) => (
          <div className="leaderboard_wrapper" key={individual.id}>
            <div className="leaderboard_wrapper__name">
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://tiltify.com` + individual.url}
              >
                {individual.name}
              </a>
            </div>
            <div className="leaderboard_wrapper__amount">
              ${formatNumber(individual.amount.value)}
            </div>
          </div>
        ))}
      </div>
      <div className="col-4">
        {props.leaderboard.slice(17, 34).map((individual) => (
          <div className="leaderboard_wrapper" key={individual.id}>
            <div className="leaderboard_wrapper__name">
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://tiltify.com` + individual.url}
              >
                {individual.name}
              </a>
            </div>
            <div className="leaderboard_wrapper__amount">
              ${formatNumber(individual.amount.value)}
            </div>
          </div>
        ))}
      </div>
      <div className="col-4">
        {props.leaderboard.slice(34, 51).map((individual) => (
          <div className="leaderboard_wrapper" key={individual.id}>
            <div className="leaderboard_wrapper__name">
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://tiltify.com` + individual.url}
              >
                {individual.name}
              </a>
            </div>
            <div className="leaderboard_wrapper__amount">
              ${formatNumber(individual.amount.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leaderboard;
